var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"100vh"},attrs:{"center":{ lat: _vm.initialPosition.lat, lng: _vm.initialPosition.lng },"zoom":15,"options":_vm.mapConfig,"map-type-id":"roadmap"}},_vm._l((_vm.markers),function(mapData){return _c('gmap-marker',{key:mapData.customer,attrs:{"position":mapData.geometry}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }